/**
 * Copyright (c) 2016-present GlossGenius. All rights reserved.
 */

import * as React from 'react';

import cx from 'classnames';
import { CanvasAnimatedTile } from 'themes/canvas/components/CanvasAnimatedTile';
import { Marquee } from 'themes/canvas/components/Marquee/Marquee';

import { Heading } from 'components/Heading';
import { NoServices } from 'components/NoServices/NoServices';

import { useServicesPage } from 'hooks/page/services/useServicesPage';

import { CanvasService } from './components/CanvasService';

import s from './CanvasServices.module.css';

const CanvasServices = () => {
  const {
    isListView,
    headingText,
    services,
    renderService,
    renderBookingHeader,
    renderSelectors,
    renderServiceProviderChangeModal,
    renderAutoBookingErrorModal,
    renderOfflineBookingModal,
    renderServiceOptionsModal,
    renderMaxAppointmentsWarning,
  } = useServicesPage();

  const singleService = services.length === 1;

  const items = services.map((service) => service.name);

  return (
    <>
      {renderBookingHeader()}
      <main>
        <section className={cx(s.root, { [s.listView]: isListView })}>
          <Heading as="h2" variant="large" className={s.servicesHeading}>
            Services
          </Heading>
          {services.length > 0 ? (
            <>
              <section className={s.servicesHeaderWrap}>
                {headingText && <h3 className={s.title}>{headingText}</h3>}
                <div className={s.selectors}>{renderSelectors()}</div>
              </section>
              <div className={s.list}>
                <div
                  className={cx(s.servicesContainer, {
                    [s.singleServiceClass]: singleService,
                  })}
                >
                  {services.map((service) => (
                    <React.Fragment key={service.guid}>
                      <CanvasAnimatedTile threshold={0}>
                        <span className={s.tile}>
                          {renderService(service, CanvasService)}
                        </span>
                      </CanvasAnimatedTile>
                    </React.Fragment>
                  ))}
                </div>
              </div>
            </>
          ) : (
            <div className={s.noServicesWrapper}>
              <NoServices />
            </div>
          )}
          {renderAutoBookingErrorModal()}
          {renderOfflineBookingModal()}
          {renderServiceProviderChangeModal()}
          {renderMaxAppointmentsWarning()}
          {renderServiceOptionsModal()}
        </section>
      </main>
      <section className={s.marquee}>
        <Marquee items={items} />
      </section>
    </>
  );
};

export { CanvasServices };
